var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "modal",
          staticStyle: { display: "block" },
          attrs: { id: "FitGuide" },
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.stopVto.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-default modal_close-btn",
                    attrs: { type: "button" },
                    on: {
                      click: _vm.stopVto,
                      touchend: function ($event) {
                        $event.preventDefault()
                        return _vm.stopVto.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-icon-close" })]
                ),
                _vm._v(" "),
                _vm.swatchProducts.length
                  ? _c(
                      "div",
                      { staticClass: "swatch_absolute-container" },
                      [
                        _vm.swatchProducts.length > 5
                          ? _c(
                              "keen-slider",
                              {
                                staticClass:
                                  "swatch_container keen-slider-vertical",
                                attrs: {
                                  options: _vm.verticalSliderOptions,
                                  arrows: "",
                                },
                              },
                              _vm._l(_vm.swatchProducts, function (prod) {
                                return _c(
                                  "div",
                                  {
                                    key: prod.id,
                                    staticClass: "product-variant_swatch",
                                    class: {
                                      current:
                                        prod.selectedOrFirstAvailableVariant
                                          .sku === _vm.currentSku,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openFrame(
                                          null,
                                          prod.selectedOrFirstAvailableVariant
                                            .sku
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          prod.images &&
                                          prod.images.edges &&
                                          prod.images.edges[0] &&
                                          prod.images.edges[0].node.url,
                                        alt: prod.title,
                                        width: "50",
                                        height: "50",
                                        loading: "lazy",
                                      },
                                    }),
                                  ]
                                )
                              }),
                              0
                            )
                          : _c(
                              "div",
                              { staticClass: "swatch_container" },
                              _vm._l(_vm.swatchProducts, function (prod) {
                                return _c(
                                  "div",
                                  {
                                    key: prod.id,
                                    staticClass: "product-variant_swatch",
                                    class: {
                                      current:
                                        prod.selectedOrFirstAvailableVariant
                                          .sku === _vm.currentSku,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openFrame(
                                          null,
                                          prod.selectedOrFirstAvailableVariant
                                            .sku
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          prod.images &&
                                          prod.images.edges &&
                                          prod.images.edges[0] &&
                                          prod.images.edges[0].node.url,
                                        alt: prod.title,
                                        width: "50",
                                        height: "50",
                                        loading: "lazy",
                                      },
                                    }),
                                  ]
                                )
                              }),
                              0
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  ref: "fitmixContainer",
                  staticClass: "popup-vto__fitmix-container",
                  attrs: { id: "my-fitmix-container" },
                }),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }